import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-4">
          {contactInfo.title}
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
          {contactInfo.desc}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-8">
          <div className="flex items-center gap-2 text-foreground-700">
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100">
              <i className="ri-mail-line text-primary-600"></i>
            </div>
            <span className="text-sm">{contactInfo.email}</span>
          </div>
          <div className="flex items-center gap-2 text-foreground-700">
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100">
              <i className="ri-wechat-line text-accent-600"></i>
            </div>
            <span className="text-sm">{contactInfo.wechat}</span>
          </div>
        </div>
        <a
          href="#contact"
          className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 bg-secondary-500 text-background-50 rounded-md text-sm font-medium hover:bg-secondary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-send-plane-line"></i>
          立即投稿
        </a>
      </div>
    </section>
  );
}